<sc-flex vertical stretchContent [gap]="16" [formGroup]="formGroup">
  @for (item of TransportStatus | keyvalue; track $index) {
    <sc-checkbox-field labelDictionaryKey="tmc-yard.common.enum.transport-processing-status.{{item.value}}" [formControlName]="item.value"></sc-checkbox-field>
  }
</sc-flex>
